import { defineMessages } from 'react-intl';

export default defineMessages({
  errorProcessingFile: {
    id: 'additionalInformation.errorProcessingFile',
    defaultMessage: 'Error processing file',
  },
  unrecognizedSerialNumber: {
    id: 'additionalInformation.unrecognizedSerialNumber',
    defaultMessage: 'Unrecognized serial number',
  },
});
